<!-- APP-APP管理-APP主表格 -->
<template>
  <div class="md-layout-item md-size-100">
    <div class="md-layout-item ">
      <md-card v-show="!showUrl">
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-主体-表单-表格数据筛选 -->
          <div class="md-layout card-form" style="max-width: 700px;">
            <!-- 表单-选择框-选择 formValue 查询类型 (1: APP ID, 2: APP名称) -->
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <md-select v-model="formData.formType">
                  <md-option :value="1">{{$I18n('app_id')}}</md-option>
                  <md-option :value="2">{{$I18n('app_name')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 表单-输入框-查询值 (1: APP ID, 2: APP名称) -->
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{ formData.formType === 1 ?$I18n('app_id') :$I18n('app_name') }}</label>
                <md-input v-model="formData.formValue"/>
              </md-field>
            </div>
            <!-- 表单-选择框-公司 -->
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("company")}}</label>
                <md-select v-model="formData.compId">
                  <md-option value="__ALL__">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in comps" :value="item.comp_id" :key="item.comp_id">{{item.comp_short_name ?item.comp_short_name : item.comp_name}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-button class= "left-icon md-info" @click="form_search">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item">
              <add-button @click="modal_openModal(null)">{{$I18n("add_app")}}</add-button>
            </div>
          </div>
          <!-- 表格 
            ID
            APP名字
            公司名字
            创建时间 (小模式下不显示)
            操作 (打开对话栏)
           -->
          <md-table v-model="table_data" > 
            <md-table-row slot="md-table-row" slot-scope="{ item }"   @click="table_selected(item)" :style="{'cursor': 'pointer'}">
              <md-table-cell :md-label="$I18n('id')" class="numbers">
                <span class="not-bind">{{ item.id }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('app_name')"> 
                <span class="not-bind">{{ item.name }}</span> 
              </md-table-cell>
              <md-table-cell :md-label="$I18n('company')">
                <span class="not-bind">{{ item.comp_name }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('type')">
                <span class="not-bind">{{ item.type_name }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('effect_time')">
                <span class="not-bind">{{ item.expire }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">
                <span class="not-bind">{{ item.create_time }}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')" class="button-box" style="width: 160px;">
                <!-- 打开URL  -->
                <table-button @click="modal_openModal(item)" icon="edit" color="md-info" />
                <table-button @click="modal_openDelModal(item)" icon="delete" color="md-danger" />
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 表格-翻页 -->
        <table-page v-if="!showUrl" :total="table_totalCount" :pageSize="pageSize" v-model="table_pageNo"/>
      </md-card>
      <!-- 弹窗 -->
      <simple-modal ref="modal" :title="modal_title" :right="true" @submit="modal_submit">
        <!-- 弹窗-主体 -->
        <template slot="body">
          <!-- 表单-APP添加/修改 -->
          <div>
            <common-form-item 
              v-for="item in form_modalData" 
              v-model="modal_data.Form[item.keys]" 
              :error="modal_data.Error[item.keys]" 
              :key="item.keys" v-bind="item"
            >
              <md-field v-if="item.keys === 'date' " class="md-theme-default md-has-value">
                <el-date-picker 
                  v-model="modal_data.Form.expire" class="md-date-form-item" align="left" type="datetime" 
                  prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$I18n('sel_time')"/>
              </md-field>
              <md-field v-if="item.keys === 'ad_limit_zone_list' " class="md-theme-default md-has-value" style="position: relative;">
                <md-input v-model="ad_limit_zone_list_name" />
                <div @click="$refs.ad_zone.open(modal_data.Form.ad_limit_zone_list.split(','))" 
                  style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"></div>
              </md-field>
              <md-field v-if="item.keys === 'oss_limit_zone_list' " class="md-theme-default md-has-value" style="position: relative;">
                <md-input v-model="oss_limit_zone_list_name" />
                <div @click="$refs.oss_zone.open(modal_data.Form.oss_limit_zone_list.split(','))" 
                  style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"></div>
              </md-field>

            </common-form-item>
          </div>
        </template>
      </simple-modal>
      <!-- 弹窗 -->
      <simple-modal ref="delete" :title="$I18n('tips')" @submit="modal_delete_submit">
        <template slot="body">
          {{$I18n("check_delete", modal_data.Form.name)}}
        </template>
      </simple-modal>
      <zone-select-mult-modal ref="ad_zone" @select="zone => (modal_data.Form.ad_limit_zone_list = zone.join(','))"/>
      <zone-select-mult-modal ref="oss_zone" @select="zone => (modal_data.Form.oss_limit_zone_list = zone.join(','))"/>
    </div>
  </div>
</template>
<script>
import { FormClass, getInitComp, timestampToString } from "@/common/tools.js";
import ZoneSelectMultModal from "@/components/Common/ZoneSelectMultModal.vue";
import {countryArray} from "@/common/continent.js";
export default {
  components: {
    ZoneSelectMultModal
  },
  props:{
    comps: { // 公司数据列表
      type : Array,
      default: (() => []),
    },
  },
  data (){
    const init_comp = this.UserInfo.role_id < 10000 ?"__ALL__" : getInitComp(this.comps, this.UserInfo.comp_id);
    return {
      card_icon : "apps", // 卡片-ICON样式
      card_title: "APP",  // 卡片-标题

      table_rawData  :[], // 表格-原始数据
      table_pageNo   : 1, // 表格-页码
      table_totalCount:0, // 表格-数据总数
      pageSize : 10,      // 表格-每页显示数量
      selectedApp: {},    // 表格-选中的APP

      modal: false,       // 弹窗-是否打开了
      modal_title: "",    // 弹窗-标题
      modal_data: new FormClass({ // 弹窗-弹窗表单数据
        comp_id : this.comps.length>0 ?this.comps[0].comp_id :"",
        app_name: {
          init :"",
          check:"required",
        },
        type :"1",
        expire:"",
        max_login: {
          init: "1",
          check: (value) => {
            return isNaN(value) ||  parseInt(value) > 5 || parseInt(value) < 1
          },
        },
        package_name_ios: {
          init :"",
          check: (value, formValue) => {
            return !formValue.id && !value;
          },
        },
        package_name_android: {
          init :"",
          check: (value, formValue) => {
            return !formValue.id && !value;
          },
        },
        phone_login_bool: true,
        email_login_bool: true,
        ad_type: -1,
        ad_interval: {
          init: '360',
          check: (value) => {
            return isNaN(value) || value < 1;
          }
        },
        ad_limit_type: -1,
        oss_limit_type: -1,
        ad_limit_zone_list: "",
        oss_limit_zone_list: "",

        app_key_ios:"",
        app_key_android:"",
        show_app_key : "1",
      }),
      ad_limit_zone_list_name:"",
      oss_limit_zone_list_name:"",

      formData : {        // 表单-查询数据
        formType  : 2,         // 决定 formValue 查询的是哪个值 [1: app_id , 2:app_name]
        formValue : "",        // 查询的值
        compId    : init_comp, // 查询哪个公司 __ALL__ 为全部 (不能为空,不然页面样式会有问题)
      },
      searchData: {        // 表单-实际请求时查询的数据
        app_id   : "",
        app_name : "",
        comp_id  : init_comp,
      },

      showUrl: "",
      // orginImgUrlList : [],
    }
  },
  computed : {
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.comps.map(i => {
            return {
              id  : i.comp_id,
              name: i.comp_name,
            }
          }),
          required: true,
        },{
          label   : this.$I18n("app_name"),
          keys    : "app_name",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : [
            {id: "1", name : this.$I18n("test_ver")},
            {id: "2", name : this.$I18n("base_ver")},
            {id: "3", name : this.$I18n("vip_ver")},
          ],
          hide    : this.UserInfo.role_id >= 10000,
          required: true,
        },{
          label   : this.$I18n("ios_package_name"),
          keys    : "package_name_ios",
          type    : "input",
          required: !this.modal_data.Form.id,
          check   : !this.modal_data.Form.id,
          hide    : !!this.modal_data.Form.id,
        },{
          label   : this.$I18n("android_package_name"),
          keys    : "package_name_android",
          type    : "input",
          required: !this.modal_data.Form.id,
          check   : !this.modal_data.Form.id,
          hide    : !!this.modal_data.Form.id,
        },{
          label   : "APP Key",
          keys    : "show_app_key",
          type    : "radio",
          options : [
            {id: "1", name : this.$I18n("auto_create")},
            {id: "2", name : this.$I18n("custom")},
          ],
          hide    : !!this.modal_data.Form.id,
        },{
          label   : "iOS Key",
          keys    : "app_key_ios",
          type    : "input",
          hide    : !!this.modal_data.Form.id || this.modal_data.Form.show_app_key == "1",
        },{
          label   : "Android Key",
          keys    : "app_key_android",
          type    : "input",
          hide    : !!this.modal_data.Form.id || this.modal_data.Form.show_app_key == "1",
        },{
          label   : this.$I18n("validity_time"),
          keys    : "date",
          hide    : this.UserInfo.role_id >= 10000,
        },{
          label   : this.$I18n("max_login") + "(1-5)",
          keys    : "max_login",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("phone_login"),
          keys    : "phone_login_bool",
          type    : "switch",
        },{
          label   : this.$I18n("email_login"),
          keys    : "email_login_bool",
          type    : "switch",
        },{
          label   : this.$I18n("ad_type"),
          keys    : "ad_type",
          type    : "select",
          options : [
            {id: -1, name: this.$I18n("none")},
            {id: 1, name: this.$I18n("topon")},
            {id: 2, name: this.$I18n("admob")},
          ]
        },{
          label   : this.$I18n("ad_int"),
          keys    : "ad_interval",
          type    : "input",
          check   : true,
        },{
          label   : this.$I18n("ad_rest_type"),
          keys    : "ad_limit_type",
          type    : "select",
          options : [
            {id: -1, name: this.$I18n("none")},
            {id: 1, name: this.$I18n("open_area")},
            {id: 2, name: this.$I18n("close_area")},
          ]
        },{
          label   : this.$I18n("ad_area_cont"),
          keys    : "ad_limit_zone_list",
        },{
          label   : this.$I18n("cloud_storage_rest"),
          keys    : "oss_limit_type",
          type    : "select",
          options : [
            {id: -1, name: this.$I18n("none")},
            {id: 1, name: this.$I18n("open_area")},
            {id: 2, name: this.$I18n("close_area")},
          ]
        },{
          label   : this.$I18n("cloud_storage_area"),
          keys    : "oss_limit_zone_list",
        },
      ]
    },
    table_data () { // 表格数据
      return this.table_rawData.filter(item => !this.showUrl || item.id === this.showUrl).map(item => {
        let comp = this.comps.filter(comp => comp.comp_id == item.comp_id)[0];
        let comp_name = this.$I18n("unknow")
        if (comp){
          comp_name = comp.comp_short_name ?comp.comp_short_name :comp.comp_name;
        }
        let type_name = this.$I18n("unknow")
        switch(item.type){
          case 1: 
            type_name = this.$I18n("test_ver");
            break;
          case 2: 
            type_name = this.$I18n("base_ver");
            break;
          case 3: 
            type_name = this.$I18n("vip_ver");
            break;
        }
        return {
          ...item,
          comp_name,
          type_name,
          ad_type : item.ad_type ?item.ad_type :-1,
          ad_limit_type : item.ad_limit_type ?item.ad_limit_type :-1,
          oss_limit_type  : item.oss_limit_type ?item.oss_limit_type :-1,
          phone_login_bool: item.phone_login == 1 ?true :false,
          email_login_bool: item.email_login == 1 ?true :false,
          ad_limit_zone_list : item.ad_limit_zone ?JSON.parse(item.ad_limit_zone).join(",") :"",
          oss_limit_zone_list : item.oss_limit_zone ?JSON.parse(item.oss_limit_zone).join(",") :"",
          expire: item.gmt_expire ?timestampToString(item.gmt_expire * 1000) :"",
          create_time : timestampToString(item.gmt_create * 1000),
        }
      });
    },
  },
  methods:{
    api_getApp(comp_id){ // API-获取APP列表
      return this.$api.queryAppBase({ // api: /user/app/query
        ...this.searchData,
        comp_id   : comp_id ?comp_id :this.searchData.comp_id,
        page_no   : this.table_pageNo,
        page_size : this.pageSize,
      })
        .then(this.$Then(res => {
          this.table_rawData = res.data;
          this.table_totalCount = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.table_rawData = [];
          this.table_totalCount =  0;
        }))
    },
    modal_openDelModal(item){
      this.modal_data.Update(item);
      this.$refs.delete.open();
    },
    modal_delete_submit(){
      this.$api.delBaseApp({
        id : this.modal_data.Form.id,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"));
          this.$refs.delete.close();
          this.api_getApp();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },

    modal_submit () { // 弹窗-提交表单
      if(this.modal_data.Check()){ // 校验必填
        this.$errorMsg(this.$I18n("pls_input") + this.$I18n("app_name"))
        return
      }
      if(this.modal_data.Form.id){ // 修改 APP 
        this.$api.editBaseApp({ // api: /user/app/set
            ...this.modal_data.Form,
            phone_login: this.modal_data.Form.phone_login_bool ?1 :2,
            email_login: this.modal_data.Form.email_login_bool ?1 :2,
            ad_limit_zone: JSON.stringify(this.modal_data.Form.ad_limit_zone_list.split(",").filter(i => !!i)),
            oss_limit_zone: JSON.stringify(this.modal_data.Form.oss_limit_zone_list.split(",").filter(i => !!i)),
            ad_interval: parseInt(this.modal_data.Form.ad_interval),
            name      : this.modal_data.Form.app_name,
            gmt_expire: new Date(this.modal_data.Form.expire).getTime() / 1000,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.$refs.modal.close();
            this.api_getApp();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      } 
      else { // 添加 APP
        this.$api.addBaseApp({ // api: /user/app/add
            ...this.modal_data.Form,
            phone_login: this.modal_data.Form.phone_login_bool ?1 :2,
            email_login: this.modal_data.Form.email_login_bool ?1 :2,
            ad_limit_zone: JSON.stringify(this.modal_data.Form.ad_limit_zone_list.split(",").filter(i => !!i)),
            oss_limit_zone: JSON.stringify(this.modal_data.Form.oss_limit_zone_list.split(",").filter(i => !!i)),
            ad_interval: parseInt(this.modal_data.Form.ad_interval),
            name      : this.modal_data.Form.app_name,
            gmt_expire: new Date(this.modal_data.Form.expire).getTime() / 1000,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("add_success"));
            this.$refs.modal.close();
            this.api_getApp();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
    },
    modal_openModal(item){ // 弹窗-打开弹窗
      if(item){
        this.modal_title = this.$I18n("edit_app");
        this.modal_data.Update({
          ...item,
          app_name : item.name,
        })
      } else {
        this.modal_title = this.$I18n("add_app");
        this.modal_data.Reset()
      }
      this.$refs.modal.open();
    },
    form_search (){ // 表单-提交查询
      let searchData = {
        app_id   : "",
        app_name : "",
        comp_id  : this.formData.compId == "__ALL__" ?"" :this.formData.compId,
      }
      let value = this.formData.formValue.replace(/^\s|\s$/g,"")
      if(this.formData.formType == 1){
        searchData.app_id = value;
      } else {
        searchData.app_name = value;
      }
      this.searchData = {...searchData}
      if(this.table_pageNo == 1){
        this.api_getApp();
      } else { // 会自动触发查询请求
        this.table_pageNo = 1;
        // console.log(this.table_pageNo)
      }
    },
    table_selected(item){ // 表格-选择内容
      if(this.showUrl){
        return;
      }
      if (item){
        this.$emit('select', item)
        this.selectedApp = item;
      } else{
        this.$emit('select', {})
        this.selectedApp = {};
      } 
    },
    table_showUrl(item){
      if(this.showUrl){
        this.showUrl = ""
      } else {
        this.showUrl = item.id;
      }
    },
  },
  watch:{
    'modal_data.Form.ad_limit_zone_list':{
      handler(newValue){
        this.ad_limit_zone_list_name = newValue.split(",")
          .map(i => countryArray.filter(j => j.code === i)[0])
          .filter(i => !!i)
          .map(i => this.$router.history.current.query.lang === "zh" ?i.cn_name :i.name)
          .join(",")
        return 
      },
      immediate: true,
      deep: true,
    },
    'modal_data.Form.oss_limit_zone_list':{
      handler(newValue){
        this.oss_limit_zone_list_name = newValue.split(",")
          .map(i => countryArray.filter(j => j.code === i)[0])
          .filter(i => !!i)
          .map(i => this.$router.history.current.query.lang === "zh" ?i.cn_name :i.name)
          .join(",")
        return 
      },
      immediate: true,
      deep: true,
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    'imgUrlList':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    table_data:{
      handler(){
        return 
      },
      deep: true,
    },
    table_pageNo(){
      this.api_getApp(); 
    },
    comps(){
      const init_comp = getInitComp(this.comps, this.UserInfo.comp_id);
      this.formData.compId   = init_comp;
      this.searchData.compId = init_comp;
      this.api_getApp(init_comp).then(() => {
        let id = this.$router.history.current.query.id;
        if(id){
          let app = this.table_rawData.filter(data => {
            return String(data.id) == String(id)
          })[0]
          if(app){
            this.modal_openModal(app)
          }
        }
      });
    },
  },
  mounted(){
    if(this.comps && this.comps.length > 0){
      this.api_getApp().then(() => {
          let id = this.$router.history.current.query.id;
          if(id){
            let app = this.table_rawData.filter(data => {
              return String(data.id) == String(id)
            })[0]
            if(app){
              this.modal_openModal(app)
            }
          }
      });
    }
  },
}
</script>